export default "__VITE_ASSET__TY0TNGIY__"